import { SaleBadgeProps } from '../../types';
import { generateSalePercentageBasedOnType } from 'utils';
import './style.scss';

export const Me2onSaleBadge = ({
  salePercentage,
  salePercentageDisplayType,
}: SaleBadgeProps) => {
  return (
    <div className="me2on-sale-badge">
      <img
        src="https://media.appcharge.com/defaults/me2on_sale-badge.png"
        alt="sale-badge"
        className="me2on-sale-badge__img"
      />
      <span className="me2on-sale-badge__number">
        {generateSalePercentageBasedOnType(
          salePercentage,
          salePercentageDisplayType,
        )}
      </span>
    </div>
  );
};
